import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec } from '../../lib/editing-configs';

const ABTestWrapper = ({ children, testName, variant }) => {
  return (
    <StructuredContent>
      {{
        type: 'ABTest',
        version: '1.0.0',
        props: {
          children,
          testName,
          variant,
        },
      }}
    </StructuredContent>
  );
};

ABTestWrapper.propTypes = {
  children: PropTypes.node,
  testName: PropTypes.string,
  variant: PropTypes.string,
};

ABTestWrapper.defaultProps = {
  children: null,
  testName: '',
  variant: '',
};

ABTestWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('testName', 'Test Name'),
    stringInputSpec('variant', 'Variant Name'),
  ];
};

ABTestWrapper.displayName = 'A/B Test';

ABTestWrapper.isContainer = true;

export default ABTestWrapper;
